import { Seo } from "@/components/Seo";
import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { formatApiError } from "@/components/auth/VerifyPanel";
import { Field, inputCls } from "@/components/auth/LoginForm";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: params.get("token"), password: pw }); toast.success("Password updated — sign in"); navigate("/auth"); }
    catch (err) { toast.error(formatApiError(err?.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#07080E] text-slate-100 grain">
      <Seo title="Reset password" description="Reset your Vectra account password." noindex />
      <nav className="h-16 px-6 sm:px-10 flex items-center border-b border-white/10"><Link to="/"><Logo size={34} /></Link></nav>
      <form data-testid="reset-form" onSubmit={submit} className="max-w-md mx-auto mt-16 glass rounded-3xl p-8 space-y-4">
        <div className="text-xs font-mono uppercase tracking-widest text-cyan-400 flex items-center gap-2"><KeyRound size={13} /> Set a new password</div>
        <Field label="New password" hint="Minimum 8 characters"><input data-testid="reset-password" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} /></Field>
        <button data-testid="reset-submit" disabled={busy} className="w-full py-3 rounded-full text-sm font-semibold bg-gradient-to-r from-purple-600 to-cyan-600 text-white disabled:opacity-50">Update password</button>
      </form>
    </div>
  );
}
